import "./index.css";
import App from "./App";
import React from "react";
import ReactDOM from "react-dom";
import { CookiesProvider } from "react-cookie";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <React.StrictMode>
    <CookiesProvider>
      <App />
    </CookiesProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
